module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "xelement"
  }, [(!_vm.isLogin) ? _c('xlogin', {
    attrs: {
      "title": _vm.title,
      "url": _vm.url.login
    },
    on: {
      "loginSuccess": _vm.loginSuccess
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "header"
  }, [_c('div', {
    staticClass: "logo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/logo.png")
    }
  }), _vm._v(" "), _c('h2', [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "tools"
  }, [_c('a', {
    staticClass: "item",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('el-tooltip', {
    attrs: {
      "content": "登出",
      "placement": "bottom"
    }
  }, [_c('i', {
    staticClass: "el-icon-x-logout"
  })])], 1), _vm._v(" "), _vm._l((_vm.tools), function(tool) {
    return _c('router-link', {
      staticClass: "item",
      attrs: {
        "to": tool.path
      }
    }, [_c('el-tooltip', {
      attrs: {
        "content": tool.title,
        "placement": "bottom"
      }
    }, [_c('i', {
      class: 'el-icon-' + tool.icon
    })])], 1)
  })], 2)]) : _vm._e(), _vm._v(" "), (_vm.isLogin) ? _c('div', {
    staticClass: "main"
  }, [_c('div', {
    staticClass: "menu"
  }, [_c('div', {
    staticClass: "userinfo"
  }, [_c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.userinfo.name))]), _vm._v(" "), _c('div', {
    staticClass: "it"
  }, [_c('span', {
    staticClass: "tit"
  }, [_vm._v("余额：")]), _vm._v("¥" + _vm._s(_vm.userinfo.balance))])]), _vm._v(" "), _c('el-menu', {
    attrs: {
      "default-active": _vm.defaultActive,
      "theme": "dark",
      "router": true,
      "unique-opened": true
    }
  }, [_vm._l((_vm.menu), function(item, index) {
    return [(item.sub != undefined) ? _c('el-submenu', {
      attrs: {
        "index": 'index-' + index
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: 'el-icon-' + item.icon
    }), _vm._v(_vm._s(item.title))]), _vm._v(" "), _vm._l((item.sub), function(it) {
      return [(it.sub != undefined) ? _c('el-menu-item-group', {
        attrs: {
          "title": it.title
        }
      }, _vm._l((it.sub), function(submenu) {
        return _c('el-menu-item', {
          attrs: {
            "index": submenu.index
          }
        }, [_vm._v(_vm._s(submenu.title))])
      })) : _vm._e(), _vm._v(" "), (it.sub == undefined) ? _c('el-menu-item', {
        attrs: {
          "index": it.index
        }
      }, [_vm._v(_vm._s(it.title))]) : _vm._e()]
    })], 2) : _vm._e(), _vm._v(" "), (item.sub == undefined) ? _c('el-menu-item', {
      attrs: {
        "index": item.index
      }
    }, [_c('i', {
      class: 'el-icon-' + item.icon
    }), _vm._v(_vm._s(item.title))]) : _vm._e()]
  })], 2)], 1), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('router-view')], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-094eca19!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/xelement/main.vue
// module id = 213
// module chunks = 2